import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    isListView?: boolean;
}

type Props = OwnProps;

export interface ProductListProductImageStyles {
    gridViewPromoMessage?: InjectableCss;
    listViewPromoMessage?: InjectableCss;
}

export const productImageStyles: ProductListProductImageStyles = {
    gridViewPromoMessage: {
        css: css`
            width: 100%;
            font-size: 14px;
            font-weight: 600;
            letter-spacing: 0;
            line-height: 17px;
            text-align: center;
            background-color: #006bc0;
            color: #ffffff;
            text-transform: uppercase;
            z-index: 10;
            padding: 5px 0;
            position: absolute;
        `,
    },

    listViewPromoMessage: {
        css: css`
            width: 263px;
            font-size: 14px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 17px;
            text-align: center;
            background-color: #006bc0;
            color: #ffffff;
            text-transform: uppercase;
            z-index: 10;
            padding: 5px 0;
        `,
    },
};

const INTPromoSlot: FC<Props> = ({ isListView }) => {
    const promoMessage = siteMessage("PromoMessage");
    return (
        <StyledWrapper
            {...(isListView
                ? { ...productImageStyles.listViewPromoMessage }
                : { ...productImageStyles.gridViewPromoMessage })}
        >
            {promoMessage}
        </StyledWrapper>
    );
};

export default INTPromoSlot;
